import { BatteryStatus } from "@/enums/Battery/BatteryStatus";

const variants = [
  "danger",
  "info",
  "success",
  "warning",
  "primary",
  "secondary",
];
var batteryArray = Object.keys(BatteryStatus);

export const getBatteryStatus = (value) => {
  const index = batteryArray.findIndex((e) => e === value); // 0
  if (index > -1) {
    const item = index % variants.length;
    return { key: value, variant: variants[item], name: BatteryStatus[value] };
  }
  return { key: value, variant: "danger", name: BatteryStatus[value] };
};
